import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ContactenosComponent } from '../../modals/contactenos/contactenos.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  openContactenosDialog = (): void => {
    const contactenosConfig = new MatDialogConfig();
    contactenosConfig.panelClass = 'contacto-modal';
    this.dialog.open(ContactenosComponent, contactenosConfig);
  }

}
